import { AxiosError } from 'axios';

import { axiosInstance } from '../requests/axios';
import { fetchLoginByToken, fetchFreshToken, logout, fetchLogin } from '../requests/requests';
import { SnackbarType } from '../types/enums';
import { StateAction, User, Notify } from '../types/types';

export const setBearerToken = (token: string) => {
  localStorage.setItem(LOCAL_STORAGE_TOKEN_KEY, token);

  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

export const getToken = () => {
  return localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
};

export const deleteToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
  axiosInstance.defaults.headers.common['Authorization'] = undefined;
};

export const loginByCredentials = (
  secToken: string,
  email: string,
  password: string,
  setUser: StateAction<User | undefined>,
  notify: Notify
) =>
  fetchLogin(email, password, secToken).then(
    ({ data }) => {
      setBearerToken(data.accessToken);
      startTokenRefreshingCountdown();
      setUser(data.user);
    },
    ({ response }: AxiosError<{ error: string[]; message?: string }>) => {
      if (response?.status === 401) {
        const msg = response?.data?.message ?? 'email or password is incorrect!';

        notify(`Login failed: ${msg}`, SnackbarType.ERROR);
      }
    }
  );

export const loginByToken = async () => {
  const localToken = getToken();

  if (!localToken) return false;

  try {
    const {
      data: { accessToken, user }
    } = await fetchLoginByToken(localToken);

    if (!accessToken) return false;

    setBearerToken(accessToken);
    startTokenRefreshingCountdown();

    return user;
  } catch (e) {
    console.error('Login by token failed', e);
    return false;
  }
};

const refreshToken = async () => {
  fetchFreshToken()
    .then(({ data }) => {
      setBearerToken(data.token);
      startTokenRefreshingCountdown();
    })
    .catch((e) => {
      console.error('Refreshing token failed', e);
    });
};

const startTokenRefreshingCountdown = () => {
  setTimeout(refreshToken, TOKEN_EXPIRE_MINUTES * 60 * 1000);
};

export const handleLogout = () => {
  logout();
  deleteToken();
};

const TOKEN_EXPIRE_MINUTES = 25;
const LOCAL_STORAGE_TOKEN_KEY = 'token';
